import { useState } from 'preact/hooks'
import { exportToCalendar, getExportMessage } from '../utils/calendarUtils'

export function ExportButton({ sessions, onExportComplete }) {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (sessions.length === 0) {
      onExportComplete && onExportComplete({
        success: false,
        message: getExportMessage(0)
      })
      return
    }

    setIsExporting(true)

    try {
      const result = await exportToCalendar(sessions)
      
      const message = result.success 
        ? getExportMessage(result.count)
        : `Export failed: ${result.error}`

      onExportComplete && onExportComplete({
        success: result.success,
        message
      })
    } catch (error) {
      onExportComplete && onExportComplete({
        success: false,
        message: `Export failed: ${error.message}`
      })
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className={`
        flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm
        transition-all duration-200 transform hover:scale-105
        ${sessions.length === 0
          ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
          : 'bg-editions-green hover:bg-editions-green/80 text-white shadow-lg shadow-editions-green/20'
        }
        ${isExporting ? 'animate-pulse' : ''}
      `}
      aria-label={`Export ${sessions.length} sessions to calendar`}
    >
      <span className="text-base">
        {isExporting ? '⏳' : '📅'}
      </span>
      <span>
        {isExporting ? 'Exporting...' : 'Export to Calendar'}
      </span>
      {sessions.length > 0 && !isExporting && (
        <span className="bg-white/20 text-xs px-2 py-0.5 rounded-full">
          {sessions.length}
        </span>
      )}
    </button>
  )
} 